// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/buy/paycell-info-dialog/paycell-info-dialog.less
// module id = 524
// module chunks = 0